import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b8b3897"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "strong pb-3"
}
const _hoisted_2 = { class: "legend" }
const _hoisted_3 = { class: "legend-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-item__color legend-item__color--in-range" }, null, -1))
const _hoisted_5 = { class: "legend-item__text" }
const _hoisted_6 = { class: "legend-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-item__color legend-item__color--discount" }, "%", -1))
const _hoisted_8 = { class: "legend-item__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'package' && _ctx.hasCalendarView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.translate('shop.ticket.configuration.rounded-price-info')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, " = " + _toDisplayString(_ctx.translate('shop.ticket.configuration.in-range-legend')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, " = " + _toDisplayString(_ctx.translate('shop.ticket.configuration.discount-legend')), 1)
      ])
    ])
  ], 64))
}